export const MAP_PAGE_MODULE_NAME = "mapPage";
export const MAP_CONTROLS_MODULE_NAME = "mapControls";
export const OPERATION_MODE_STORED_KEY = "mapActiveOperationMode";
